import { Controller } from "@hotwired/stimulus"

// Admin-only switch that reveals the chat drawer's raw tool calls and
// results. Flips data-tool-details on the group element (CSS does the
// showing) and remembers the choice per browser.
const STORAGE_KEY = "chat:toolDetails"

export default class extends Controller {
  static targets = ["toggle"]

  connect() {
    let shown = false
    try { shown = localStorage.getItem(STORAGE_KEY) === "shown" } catch {}
    this.apply(shown && this.hasToggleTarget)
  }

  toggle() {
    const shown = this.element.dataset.toolDetails !== "shown"
    try { localStorage.setItem(STORAGE_KEY, shown ? "shown" : "hidden") } catch {}
    this.apply(shown)
  }

  apply(shown) {
    this.element.dataset.toolDetails = shown ? "shown" : "hidden"
    if (this.hasToggleTarget) this.toggleTarget.setAttribute("aria-pressed", String(shown))
  }
}
